import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import authAtom, { isAuthInitializedAtom } from '../features/auth/authAtom';
import { Spin } from 'antd';

interface Props {
  children: ReactElement;
}

const GuestRoute = ({ children }: Props): ReactElement => {
  const session = useAtomValue(authAtom);
  const initialized = useAtomValue(isAuthInitializedAtom);
  if (!initialized) return <Spin />;
  if (session) return <Navigate to='/history' replace />;
  return children;
};

export default GuestRoute;
